import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import jwt_decode, { jwtDecode } from 'jwt-decode';
import { BehaviorSubject, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthService {
getUserRole() {
throw new Error('Method not implemented.');
}

  private isLoggedInSubject = new BehaviorSubject<boolean>(this.hasToken());
  isLoggedIn$ = this.isLoggedInSubject.asObservable();  // برای استفاده در component

  private hasToken(): boolean {
    return !!localStorage.getItem('getToken');
  }
  
  private baseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  register(registerData: any) {
    return this.http.post(`${this.baseUrl}/auth/register`, registerData);
  }

  login(credentials: { username: string; password: string }) {
    return this.http.post(`${this.baseUrl}/auth/login`, credentials).pipe(
      tap((res: any) => {
        this.saveToken(res.token);
        this.isLoggedInSubject.next(true); // بعد از ورود، مقدار true بده
      })
    );
  }

   logout() {
    localStorage.removeItem('getToken');
    this.isLoggedInSubject.next(false); // بعد از خروج مقدار false بده
  }
// const token = this.authService.getToken();
//   getRole(): string | null {
//   const token = localStorage.getItem('getToken');
//   if (!token) return null;

//   const decoded: any = jwtDecode(token);
//   // return decoded.role || null;
//    return decoded.role || decoded['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] || null;

// }

getRole(): string | string[] | null {
  const token = localStorage.getItem('getToken');
  if (!token) return null;

  const decoded: any = jwtDecode(token);

  const role = decoded.role || decoded['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] || null;
  return role;
}

isAdmin(): boolean {
  return this.getRole() === 'admin';
}

isEditor(): boolean {
  const role = this.getRole();

  if (Array.isArray(role)) {
    return role.some(r => r.toLowerCase() === 'editor');
  }

  return (role as string).toLowerCase() === 'editor';
}


// isManager(): boolean {
//   return this.getRole() === 'manager';
// }
// isAdminOrEditor(): boolean {
//   const role = this.getRole();
//   return role === 'admin' || role === 'editor';
// }


  // // تابعی برای چک کردن نقش کاربر
  // isAdmin(): boolean {
  //   const role = this.getRoleFromToken();
  //   return role === 'admin';  // اگر نقش 'admin' بود، true برمی‌گرداند
  // }

  saveToken(token: string) {
    localStorage.setItem('getToken', token);
  }

  getToken(): string | null {
    return localStorage.getItem('getToken');
  }

  isLoggedIn(): boolean {
    return !!this.getToken();
  }

  // درخواست‌هایی که نیاز به Authorization دارند
  getAdminData() {
    // const token = localStorage.getItem('jwtToken');
    const token = this.getToken();
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.get('https://cdick.ir/api/admin-data', { headers });
  }

  // تابعی برای دیکد کردن توکن
  decodeToken(token: string): any {
    // return jwt_decode(token); // دیکد کردن توکن و برگرداندن اطلاعات آن
  }

  // تابعی برای گرفتن نقش از توکن
  getRoleFromToken(): string | null {
    // const token = localStorage.getItem('jwtToken');
    const token = this.getToken();
    if (token) {
      const decodedToken = this.decodeToken(token); 
      return decodedToken.role;  // نقش کاربر از توکن
    }
    return null;
  }


//   getUserRole(): string | null {
//   // const token = localStorage.getItem('token');
//   const token = localStorage.getItem('getToken');
//   if (!token) return null;

//   const decoded: any = jwtDecode(token);
//   return decoded['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] || null;
// }



}
